import _ from 'lodash';
import { MyWeeklySchedule } from '../residential-devices/thermostat/types';

type MyMinMax = {
  min?: number;
  max?: number;
};

export const applySetpointLimitToWeeklyScheduleValues = (
  suppliedWeeklySchedule: MyWeeklySchedule | undefined,
  limits: {
    cool: MyMinMax;
    heat: MyMinMax;
  },
) => {
  const schedule = _.cloneDeep(suppliedWeeklySchedule);

  if (schedule) {
    // Loop through days of week
    for (const day in schedule) {
      // Loop through transitions in this day
      for (const start in schedule[day as keyof MyWeeklySchedule]) {
        // Convert setpoint min/max to Celsius with desired digits of precision
        const setpoint = schedule[day as keyof MyWeeklySchedule][start];

        // Cool setpoint
        if (typeof setpoint?.maximum === 'number') {
          if (typeof limits.cool?.max === 'number') {
            if (setpoint.maximum > limits.cool.max)
              setpoint.maximum = limits.cool.max;
          }
          if (typeof limits.cool?.min === 'number') {
            if (setpoint.maximum < limits.cool.min)
              setpoint.maximum = limits.cool.min;
          }
        }
        // Heat setpoint
        if (typeof setpoint?.minimum === 'number') {
          if (typeof limits.heat?.max === 'number') {
            if (setpoint.minimum > limits.heat.max)
              setpoint.minimum = limits.heat.max;
          }
          if (typeof limits.heat?.min === 'number') {
            if (setpoint.minimum < limits.heat.min)
              setpoint.minimum = limits.heat.min;
          }
        }
      }
    }
  }

  return schedule;
};

/** Validate the complete proposed schedule, preserving absent targets. */
export function validateScheduleLimitValues(
  schedule: MyWeeklySchedule | undefined,
  limits: { cool: MyMinMax; heat: MyMinMax },
): string[] {
  const issues: string[] = [];
  for (const day of Object.values(schedule ?? {}))
    for (const setting of Object.values(day ?? {})) {
      if (!setting) continue;
      for (const key of ['minimum', 'maximum'] as const) {
        const value = setting[key];
        if (value === undefined) continue;
        const range = limits[key === 'minimum' ? 'heat' : 'cool'];
        if (
          !Number.isFinite(value) ||
          range.min === undefined ||
          range.max === undefined ||
          !Number.isFinite(range.min) ||
          !Number.isFinite(range.max) ||
          range.min > range.max ||
          value < range.min ||
          value > range.max
        )
          issues.push(`Scheduled ${key} is outside the available policy.`);
      }
      if (
        setting.minimum !== undefined &&
        setting.maximum !== undefined &&
        setting.minimum > setting.maximum
      )
        issues.push('Scheduled heat target exceeds cool target.');
    }
  return issues;
}
